import React from 'react';

export default function PageNotFound() {
  // @Todo(Raj): Nice UI
  return (
    <div>
      <p>Page not found</p>
    </div>
  );
};